import Immutable from 'immutable';

export enum RFIAttachmentTypes {
  FILE = 'FILE',
  DRAWING = 'DRAWING',
  IMAGE = 'IMAGE',
  MARKUP = 'MARKUP',
  DISCUSSION = 'DISCUSSION',
}

export interface RawRFIAttachment {
  rfiid: string;
  fileid: string;
  name: string;
  type: string;
}

export interface RFIAttachmentData {
  rfiid: string;
  fileid: string;
  name: string;
  type: RFIAttachmentTypes;
}

const defaultValues: RFIAttachmentData = {
  rfiid: '',
  fileid: '',
  name: '',
  type: RFIAttachmentTypes.FILE,
};

export const RFIAttachmentFactory = Immutable.Record(
  defaultValues,
  'RFIAttachment'
);

export class RFIAttachment extends RFIAttachmentFactory {
  static deserialize(rawRFIAttachment: RawRFIAttachment): RFIAttachment {
    const attachmentType: RFIAttachmentTypes =
      RFIAttachmentTypes[
        rawRFIAttachment.type as keyof typeof RFIAttachmentTypes
      ];

    return new RFIAttachment({
      ...rawRFIAttachment,
      type: attachmentType,
    });
  }

  serialize(): RawRFIAttachment {
    return this.toJS();
  }
}
